import { ComponentProps } from 'preact';

import { Badge } from '@/components/badges';

interface HabitatStatusProps extends ComponentProps<typeof Badge> {
  online: boolean;
  liveTalk: boolean;
}

const HabitatStatus = ({ online, liveTalk, ...props }: HabitatStatusProps) => {
  const label = liveTalk ? 'Live Event' : online ? 'Online' : 'Asleep';
  const variant = liveTalk ? 'yellow' : online ? 'green' : 'stone';

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Badge variant={variant} {...props}>
      {label}
    </Badge>
  );
};

export default HabitatStatus;
